// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Card } from 'material-ui/Card';

import Header from './Header';
import Table from './Table';

const getStyles = ({ isMobile, feature }) => ({
  card: {
    position: 'fixed',
    left: isMobile ? 0 : '50%',
    marginLeft: isMobile ? 0 : -260,
    bottom: feature ? 0 : -100,
    zIndex: 11,
    width: 520,
    maxWidth: '100vw',
  },
});

export default class extends Component {
  state = {
    isExpanded: true,
  };

  isExpandable = () => {
    const { feature, followedAircraft } = this.props;

    if (feature) {
      const { type } = feature;
      return type === 's' || (type === 'ac' && followedAircraft);
    }

    return false;
  };

  componentWillUpdate(nextProps) {
    if (nextProps.feature !== this.props.feature) {
      this.setState({ isExpanded: true });
    }
  }

  onStateChange() {
    const { feature } = this.props;

    if (this.isExpandable()) {
      this.setState({ isExpanded: !this.state.isExpanded });
    } else {
      this.props.pushRoute('/');
    }
  }

  render() {
    const {
      browser,
      feature,
      followedAircraft,
      hasSubscription,
      saveUserTemplateFromNotice,

      toggleSearchResultsDialog,
      toggleNotamDetailsDialog,
      setFollowedAircraft,
    } = this.props;

    const isMobile = browser.lessThan.medium;
    const styles = getStyles({ isMobile, feature });

    return (
      <Card zDepth={1} style={styles.card} expanded>
        <Header
          feature={feature}
          isMobile={isMobile}
          hasSubscription={hasSubscription}
          onSearchDetailsClick={() => toggleSearchResultsDialog(true)}
          onNotamDetailsClick={() => toggleNotamDetailsDialog(true)}
          onSaveTemplateClick={() =>
            saveUserTemplateFromNotice(feature.name, feature.type, feature.slug)
          }
          onClose={this.onStateChange.bind(this)}
          expandable={this.isExpandable()}
          isExpanded={this.state.isExpanded}
          followedAircraft={followedAircraft}
          onSetFollowedAircraft={setFollowedAircraft}
        />
        {this.state.isExpanded && (
          <Table
            feature={feature}
            isMobile={isMobile}
            isFollowing={!!followedAircraft}
          />
        )}
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./components/PropSheet/PropSheet.js